<!-- HEADER -->
<div class="dialog-header" cdkDrag cdkDragRootElement=".cdk-overlay-pane">
  <div class="header-side"></div>
  <div class="dialog-title-text" cdkDragHandle>{{ dialogTitle }}</div>
  <button mat-icon-button class="close-btn" (click)="onClose()">
    <mat-icon>close</mat-icon>
  </button>
</div> 
<mat-dialog-content class="mat-typography">
  <table mat-table [dataSource]="documents" class="w-full viewport">
    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element">
        <div class="flex gap-2">
          @if(canShowGridActions){
            <button mat-icon-button
                    color="warn"
                    (click)="deleteHaulerRecord(element)"
                    style="color: red">
              <mat-icon>delete</mat-icon>
            </button>
          }
          <!-- <button mat-icon-button (click)="onViewDocument(element)">
            <mat-icon>visibility</mat-icon>
          </button> -->
        </div>
      </td>
    </ng-container>
    <ng-container matColumnDef="id">
      <th mat-header-cell *matHeaderCellDef>Id</th>
      <td mat-cell *matCellDef="let element">{{ element.id }}</td>
    </ng-container>
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef>Name</th>
      <td mat-cell *matCellDef="let element">
        <a (click)="onDownloadDocument(element)" class="document-link">
          {{ element.name.length > 30 ? (element.name | slice:0:30) + '...' : element.name }}
        </a>
        <!-- {{
            element.name.length > 30
              ? (element.name | slice : 0 : 30) + "..."
              : element.name
        }} -->
      </td>
    </ng-container>
    <ng-container matColumnDef="type">
      <th mat-header-cell *matHeaderCellDef>Type</th>
      <td mat-cell *matCellDef="let element">{{ element.docTypeName }}</td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>

  @if (documents.length === 0) {
  <div class="p-4 text-center text-gray-500">No documents found.</div>
  }
</mat-dialog-content>
<mat-card-actions align="end" class="p-4 bg-gray-100 border-t">
  <button mat-raised-button color="primary" (click)="onClose()">
    Close
  </button>
</mat-card-actions>
